var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_260_1650)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_260_1650)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    rx: 41.5,
    transform: "matrix(-1 0 0 1 92 9)",
    fill: "#FF5910"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 86,
    height: 86,
    rx: 43,
    transform: "matrix(-1 0 0 1 95 9)",
    stroke: "white",
    strokeWidth: 3
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1757 50.7806H65.2722V48.4794C65.2722 47.2091 64.2413 46.1782 62.971 46.1782H56.0675C54.7973 46.1782 53.7664 47.2091 53.7664 48.4794V50.7806H28.4535C27.1832 50.7806 26.1523 51.8115 26.1523 53.0817C26.1523 54.352 27.1832 55.3829 28.4535 55.3829H53.7664V57.6841C53.7664 58.9543 54.7973 59.9852 56.0675 59.9852H62.971C64.2413 59.9852 65.2722 58.9543 65.2722 57.6841V55.3829H72.1757C73.446 55.3829 74.4769 54.352 74.4769 53.0817C74.4769 51.8115 73.446 50.7806 72.1757 50.7806Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4535 38.1246H36.5076V40.4258C36.5076 41.696 37.5385 42.7269 38.8088 42.7269H45.7123C46.9825 42.7269 48.0134 41.696 48.0134 40.4258V38.1246H72.1757C73.446 38.1246 74.4769 37.0937 74.4769 35.8234C74.4769 34.5532 73.446 33.5223 72.1757 33.5223H48.0134V31.2211C48.0134 29.9508 46.9825 28.9199 45.7123 28.9199H38.8088C37.5385 28.9199 36.5076 29.9508 36.5076 31.2211V33.5223H28.4535C27.1832 33.5223 26.1523 34.5532 26.1523 35.8234C26.1523 37.0937 27.1832 38.1246 28.4535 38.1246Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1757 68.0398H48.0134V65.7387C48.0134 64.4684 46.9825 63.4375 45.7123 63.4375H38.8088C37.5385 63.4375 36.5076 64.4684 36.5076 65.7387V68.0398H28.4535C27.1832 68.0398 26.1523 69.0707 26.1523 70.341C26.1523 71.6113 27.1832 72.6422 28.4535 72.6422H36.5076V74.9433C36.5076 76.2136 37.5385 77.2445 38.8088 77.2445H45.7123C46.9825 77.2445 48.0134 76.2136 48.0134 74.9433V72.6422H72.1757C73.446 72.6422 74.4769 71.6113 74.4769 70.341C74.4769 69.0707 73.446 68.0398 72.1757 68.0398Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_260_1650",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.89 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_260_1650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_260_1650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_260_1650",
    x: -5,
    y: -5,
    width: 111,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_260_1650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_260_1650",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSelectIcon);
export default __webpack_public_path__ + "static/media/videoSelectIcon.8d611225d4be31873b527584ace0ef2e.svg";
export { ForwardRef as ReactComponent };